import { FinanceOptionRecord, IFinanceOptionData, financeOptionFromJSON } from "common/records/FinanceOption";
import { Record } from "immutable";
import { DateStringNumber, Nullable } from "common/records";
import { checkDate } from "common/helpers/Date";
import { round } from "lodash";

export const fromJSON = (json: Partial<IEstimateFinanceOptionData>): EstimateFinanceOptionRecord => {
  const record: IEstimateFinanceOptionRecord = { ...(json as any) };

  if (json.created_at) {
    record.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    record.updated_at = checkDate(json.updated_at);
  }

  record.finance_option = json.finance_option ? financeOptionFromJSON(json.finance_option) : null;

  return new EstimateFinanceOptionRecord(record);
};

export const toJSON = (record: EstimateFinanceOptionRecord): IEstimateFinanceOptionData => {
  return record.toJS();
};

/**
 * @param principal
 * @param annualRate - a percentage, e.g. 5.99 for 5.99%
 * @param termMonths
 * @returns
 */
export const calculateMonthlyPayment = (
  principal: number,
  annualRate: Nullable<number>,
  termMonths: Nullable<number>,
): number => {
  if (!termMonths || !principal) {
    return 0;
  }

  if (!annualRate) {
    return round(principal / termMonths, 2);
  }

  const monthlyRate = annualRate / 100 / 12;
  const payment =
    (principal * (monthlyRate * Math.pow(1 + monthlyRate, termMonths))) / (Math.pow(1 + monthlyRate, termMonths) - 1);

  return round(payment, 2);
};

export interface IEstimateFinanceOptionData {
  id: number;
  finance_option_id: number;
  estimate_id: number;
  monthly_payment: number;
  promo_payment: number;
  amount: number;
  finance_option: IFinanceOptionData;
  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface IEstimateFinanceOptionRecord {
  id: number;
  finance_option_id: number;
  estimate_id: number;
  monthly_payment: number;
  promo_payment: number;
  amount: number;
  finance_option: Nullable<FinanceOptionRecord>;
  created_at: Date;
  updated_at: Date;
  _destroy: Nullable<boolean>;
}

export const defaultEstimateFinanceOptionProps: IEstimateFinanceOptionRecord = {
  id: 0,
  finance_option_id: 0,
  estimate_id: 0,
  monthly_payment: 0,
  promo_payment: 0,
  amount: 0,
  finance_option: null,
  created_at: new Date(),
  updated_at: new Date(),
  _destroy: null,
};

export class EstimateFinanceOptionRecord
  extends Record(defaultEstimateFinanceOptionProps)
  implements IEstimateFinanceOptionRecord {}

export const emptyEstimateFinanceOptionRecord = fromJSON({});
